<script>
  export let fullnessPercent = 40;
</script>
<div style="height: 5px; margin: none; width: 100%; left: 0px; top: 0px; background-color: none">
  <div style="height: 5px; width: {fullnessPercent}%; margin: none; padding: none; left: 0px; top: 0px; background-color: rgb({55+200*(100-fullnessPercent)/100}, {55+200*(fullnessPercent)/100}, 150)"></div>
</div>